import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Location } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Subject } from 'rxjs';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query searchLocationSectors($where: LocationSectorWhereInput, $limit: Int, $offset: Int) {
    locationSectors(
      where: $where
      orderBy: name_asc
      limit: $limit
      offset: $offset
    ){
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'fc-location-sector-input',
  templateUrl: './fc-location-sector-input.component.html',
  styleUrls: ['./fc-location-sector-input.component.scss']
})
export class FcLocationSectorInputComponent {
  @Input()
  public control: FormControl;

  @Input()
  public locationId: string;

  @Input()
  public showSearchIcon = false;

  @Input()
  public requiredMark = false;

  @Input()
  public preloadOptions = false;

  @Input()
  public searchOnFocus = false;

  @Input()
  public enableInfiniteScroll = true;

  @Input()
  public showChevronIcon = false;

  @Input()
  public translateErrorPrefix: string;

  public reload$ = new Subject<void>();

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly apollo: Apollo
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  public async search(searchTerm: string, limit: number, offset: number): Promise<any[]> {
    if (!this.locationId) {
      return;
    }

    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            locationId: this.locationId,
            nameContains: searchTerm,
            archived: false
          },
          limit,
          offset
        },
      })
      .toPromise()
      .then((result) => {
        return result.data['locationSectors']['items'];
      })
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  public displayWith(value: Location): string {
    return value && value.name;
  }
}
